module.exports = __webpack_public_path__ + "assets/main-3a3825578adeff193d58c2ba09c11d86.jpg";